module.exports = __webpack_public_path__ + "static/img/301.da5e2f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/301.jpg
// module id = CSwg
// module chunks = 0